<template>
  <div>
    <loader :loading="loading"/>
    <div v-if="!loading" >
      <div>
        <general-main :product="product" :identifier="identifier"/>

        <panel title="Informações">
          <div class="l-row">
            <div class="l-col-12@md">
               <span class="ds-block">
                 <strong>Categoria:</strong>
                 {{ category.name }}
               </span>
            </div>

            <div class="l-col-12@md margin">
               <span class="ds-block">
                 <strong>{{ $t('typeCheckout.label') }}:</strong>
                 <span class="badge queue">{{ product.typeCheckout ? 'Sim' : 'Não' }}</span>
               </span>
            </div>
          </div>
          <div class="l-row margin">
            <div class="l-col-4@md">
               <span class="ds-block">
                 <strong>Forma de envio:</strong>
                 {{ $t(`mercadoLivre.shippingOptions.${product.shippingMode}.label`) | attribute }}
               </span>
            </div>
            <div class="l-col-4@md">
               <span class="ds-block">
                 <strong>Tipo:</strong>
                 {{ $t(`mercadoLivre.types.${product.type}.label`) | attribute }}
               </span>
            </div>
          </div>
          <div class="l-row">
            <div class="l-col-4@md">
               <span class="ds-block margin">
                 <strong>Condição:</strong>
                 {{ $t(`mercadoLivre.conditions.${product.condition}.label`) | attribute }}
               </span>
            </div>
            <div class="l-col-4@md" v-if="product.code">
              <div class="margin">
                <span class="ds-block margin">
                  <strong>Código:</strong>
                  <a v-if="product.link" :href="product.link"  target="_blank">
                    <span class="hint hint--bottom" data-label="Clique para acessar no marketplace"> {{ product.code }} <i class="icon-new-tab"/></span>
                  </a>
                  <span v-else>{{ product.code }}</span>
                </span>
              </div>
            </div>
            <div class="l-col-4@md">
               <span class="ds-block margin">
                 <strong>Data de criação:</strong>
                 {{ product.createdAt | moment('DD/MM/YYYY') }}
                 <span class="hint hint--top" data-label="Data de criação ou última migração do anúncio no Placemarket.">
                  <i class="fa fa-question-circle"></i>
                 </span>
               </span>
            </div>
          </div>
        </panel>

         <panel title="Produto vínculado" v-if="productCatalog">
           <panel class="blue-panel">
             <panel>
               <div class="product-catalog">
                 <div class="img-container">
                   <img :src="productCatalog.pictures[0].url">
                 </div>

                 <div class="title">
                   {{ productCatalog.name }}
                 </div>
               </div>
             </panel>
           </panel>
         </panel>

        <panel title="Frete">
          <div class="l-row">
            <form-group class="l-col-2@md" label="Frete grátis">
              <label class="form-switch">
                <input type="checkbox" v-model="product.shippingFree">
                <span class="form-switch__indicator"></span>
              </label>
              <small class="form-help">Define se o frete do anúncio será grátis.</small>
            </form-group>

            <loader :loading="loadingShippingRules"/>
            <div class="l-col-8@md"
                 v-if="verifyShippingRule(product.shippingMode) && product.shippingFree && !loadingShippingRules">
              <strong>Em caso de frete grátis, escolha a regra:</strong>
              <div v-for="shippingRule in shippingRules" :key="shippingRule"
                   class="l-row">
                <form-group :columns="4">
                  <radio-button :options="getShippingRuleOptions(shippingRule)"
                                :checkedDefault="shippingRuleSelected"
                                :toggleChecked="onChangeShippingRule"
                                :name="announcementConfiguration.identifier"/>
                </form-group>

                <form-group label="Regiões não atendidas" v-if="shippingRuleSelected === 'exclude_region' ">
                  <multiselect
                      v-model="shippingRuleSelectedRegion"
                      :options="regions"
                      selectLabel=""
                      selectedLabel=""
                      placeholder="Escolha"
                      :multiple="true"
                  />
                </form-group>
              </div>
            </div>
          </div>
        </panel>

        <panel title="Atributos" v-if="category.attributes.length">
          <general-attributes :product="product" @reloadSizes="setVariationSizes" :attributes="category.attributes"/>
        </panel>

        <fiscal-attributes :product="product"></fiscal-attributes>

        <product-edit-bulk-price :product="product"/>

        <variation :sourceProduct="sourceProduct" :product="product" :category="category"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import api from '@/api'
  import Loader from '@/components/template/Loader'
  import Panel from '@/components/template/Panel'
  import GeneralMain from '@/components/marketplace/mercadoLivre/announcement/general/Main'
  import GeneralAttributes from '@/components/marketplace/mercadoLivre/announcement/general/Attributes'
  import Variation from '@/components/marketplace/mercadoLivre/announcement/edit/Variation'
  import FiscalAttributes from '@/components/marketplace/mercadoLivre/announcement/general/FiscalAttributes'
  import ProductEditBulkPrice from '@/components/marketplace/shared/ProductEditBulkPrice'
  import notifier from '@/notifier'
  import FormGroup from '@/components/template/FormGroup'
  import RadioButton from '@/components/template/RadioButton'
  import Multiselect from 'vue-multiselect'

  export default {
    inject: ['moduleDI'],
    data: () => ({
      loading: true,
      loadingShippingRules: false,
      category: {
        attributes: []
      },
      mlProductAttributes: [],
      productCatalog: null,
      accounts: [],
      announcementConfiguration: [],
      regions: [],
      shippingRules: [],
      acceptedMethods: [],
      defaultRule: false,
      shippingRuleSelected: 'country',
      shippingRuleSelectedRegion: [],
      identifier: 'mercadoLivre',
      sizes: [],
      variationSizes: []
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      sourceProduct: {
        type: Object,
        required: true
      }
    },
    async mounted () {
      if (this.product.typeCheckout) {
        try {
          const ean = this.product.variations[0].attributes['EAN'] || this.product.variations[0].attributes.find(attribute => attribute.id === 'EAN').value_name

          if (ean) {
            const productCatalog = await api.mercadoLivre.getProductCatalog(ean)
            this.productCatalog = productCatalog.id === this.product.productCatalogId ? productCatalog : null
          }
        } catch (e) {
          this.productCatalog = null
        }
      }

      if (this.product.shippingFree) {
        this.accounts = (await api.mercadoLivre.getAccounts({})).items

        for (const account of this.accounts) {
          if (account.identifier === this.product.account.identifier) {
            this.announcementConfiguration = account
          }
        }
        if (this.product.shippingFree) {
          this.shippingRuleSelected = this.product.shippingFreeRule.rule
          this.shippingRuleSelectedRegion = this.product.shippingFreeRule.ruleRegion
        }

        await this.getShippingRules()
      }

      let variationCombination

      if (this.product.variationsCombination !== null) {
        variationCombination = this.product.variationsCombination
      }

      api.mercadoLivre.getCategoryInfo('', this.product.category, variationCombination)
        .then(category => {
          this.category = category

          if (category.path_from_root) {
            this.category.name = category.path_from_root.map(path => (path.name)).join(' > ')
          }

          for (let i in this.category.variations_attributes) {
            const attr = this.category.variations_attributes[i]
            attr.required = !!(attr.tags && attr.tags.required)
          }
        })
        .catch(() => {
          this.category.name = '-'

          notifier.error('Falha ao carregar a categoria do anúncio, desvincule o anúncio e realize a migração novamente.', 'Erro')

          this.$router.push('/marketplace/mercadoLivre/announcements')
        })
        .finally(() => { this.loading = false })
    },
    methods: {
      ...mapActions('errors', [
        'addError',
        'clearErrors'
      ]),
      setVariationSizes (sizes) {
        this.category.variations_attributes.find(attribute => attribute.id === 'SIZE').values = sizes
      },
      onChangeShippingRule (identifier, code) {
        if (identifier && code) {
          this.shippingRuleSelected = code
          this.product.shippingFreeRule = {
            rule: this.shippingRuleSelected,
            ruleRegion: this.shippingRuleSelectedRegion,
            acceptedMethods: this.acceptedMethods,
            default: this.defaultRule
          }
        }
      },
      getLabel () {
        return `${this.announcementConfiguration.name} (${this.announcementConfiguration.nickname})`
      },
      getShippingRuleOptions (shippingRule) {
        const optionsRules = []

        for (const logisticTypes of shippingRule.logistic_types) {
          this.acceptedMethods = logisticTypes.attributes.free.accepted_methods
          for (const freeRules of logisticTypes.attributes.free.rules) {
            if (freeRules.free_mode === 'exclude_region' || freeRules.free_mode === 'country') {
              optionsRules.push({
                code: freeRules.free_mode,
                label: this.$t(`mercadoLivre.shippingRules.${freeRules.free_mode}.label`)
              })

              this.defaultRule = freeRules.default

              if (freeRules.free_mode === 'exclude_region') {
                this.regions = freeRules.value
              }
            }
          }
        }
        return optionsRules
      },
      verifyShippingRule (shippingOption) {
        for (const shipping of this.shippingRules) {
          for (const logisticTypes of shipping.logistic_types) {
            if (shipping.mode === shippingOption && logisticTypes.attributes.free_shipping) {
              return false
            }
          }
        }
        return false
      },
      async getShippingRules () {
        if (this.announcementConfiguration && this.product.category) {
          const dimensions = `${this.sourceProduct.variations[0].height}x${this.sourceProduct.variations[0].width}x${this.sourceProduct.variations[0].length},${this.sourceProduct.variations[0].weight}`
          try {
            this.shippingRules = await api.mercadoLivre.getShippingRules(this.product.category, this.announcementConfiguration.identifier, dimensions)
          } catch (e) {
            notifier.error('Falha ao carregar formas de envio do anúncio.', 'Erro')
          }
        }
      },
      formatProduct () {
        this.clearErrors()

        const attributes = this.product.attributes
        const productAttributes = []

        if (this.isUseUniquePrice(this.product.productId)) {
          const productUniquePrice = this.getProductUniquePrice(this.product.productId)

          if (productUniquePrice !== undefined) {
            for (let i in this.product.variations) {
              this.product.variations[i].price = productUniquePrice.price
            }
          }
        }

        for (let i in Object.keys(attributes)) {
          const attributeId = Object.keys(attributes)[i]
          const attributeValue = attributes[attributeId]
          const attribute = this.category.attributes.find(attribute => attribute.id === attributeId)

          if (!attribute) continue

          if (attribute.tags && attribute.tags.required && attributeValue === null) {
            this.addError({
              productId: this.product.productId,
              sku: this.product.productId,
              property: attributeId,
              error: {
                message: 'required',
                value: 1
              }
            })
          }

          if (attributeValue !== null && attributeValue !== '') {
            let complement = ''
            if (attribute.default_unit) {
              complement = ' ' + attribute.default_unit
            }

            let attributeTemp = {
              id: attributeId,
              value_name: attributeValue + complement,
              name: attribute.name
            }

            if (attribute.values) {
              const selectedValue = attribute.values.find(value => value.id === attributeValue)

              if (selectedValue) {
                if (!selectedValue.custom) {
                  attributeTemp.value_id = selectedValue.id
                }
                attributeTemp.value_name = selectedValue.name
              }
            }

            if (attributeId === 'BRAND' || attributeId === 'MODEL') {
              if (attributeTemp.value_id === undefined) {
                attributeTemp.value_id = attributeTemp.value_name
              }
            }

            productAttributes.push(attributeTemp)
          }
        }

        let variations = null

        if (this.product.variationsCombination !== null) {
          variations = this.product.variations
            .filter(variation => variation.selected)
            .map(variation => {
              const attributes = variation.attributes

              const variationAttributes = []
              for (let i in Object.keys(attributes)) {
                const attributeId = Object.keys(attributes)[i]
                const attributeValue = attributes[attributeId]
                const attribute = this.category.variations_attributes.find(attribute => attribute.id === attributeId)

                if (!attribute) continue

                if ((attribute.tags && attribute.tags.required || attribute.required) && attributeValue === null) {
                  this.addError({
                    productId: this.product.productId,
                    sku: variation.sku,
                    property: attributeId,
                    error: {
                      message: 'required',
                      value: 1
                    }
                  })
                }

                if (attributeValue !== null && attributeValue !== '') {
                  let complement = ''
                  if (attribute.default_unit) {
                    complement = ' ' + attribute.default_unit
                  }

                  let attributeTemp = {
                    id: attributeId,
                    value_name: attributeValue + complement,
                    name: attribute.name
                  }

                  if (attribute.values) {
                    const selectedValue = attribute.values.find(value => value.id === attributeValue)

                    if (selectedValue) {
                      if (!selectedValue.custom) {
                        attributeTemp.value_id = selectedValue.id
                      }
                      attributeTemp.value_name = selectedValue.name + complement
                    }
                  }

                  variationAttributes.push(attributeTemp)
                }
              }

              const images = []
              for (let i in variation.images) {
                let image = variation.images[i]

                let url = ''
                if (typeof image === 'string' || image instanceof String) {
                  url = image
                }

                images.push({
                  url: url.length === 0 ? image.url : url,
                  code: image.code ? image.code : null
                })
              }

              return {
                attributes: variationAttributes,
                images: images,
                original: variation,
                price: variation.price,
                sku: variation.sku,
                stock: variation.stock,
                code: variation.code,
                saleAvailability: variation.saleAvailability
              }
            })
        } else {
          const variation = this.product.variations[0]
          const attributes = variation.attributes

          const variationAttributes = []
          for (let i in Object.keys(attributes)) {
            const attributeId = Object.keys(attributes)[i]
            const attributeValue = attributes[attributeId]
            const attribute = this.category.variations_attributes.find(attribute => attribute.id === attributeId)

            if (!attribute) continue

            if (attribute.tags && attribute.tags.required && attributeValue === null) {
              this.addError({
                productId: this.product.productId,
                sku: variation.sku,
                property: attributeId,
                error: {
                  message: 'required',
                  value: 1
                }
              })
            }

            if (attributeValue !== null && attributeValue !== '') {
              let complement = ''
              if (attribute.default_unit) {
                complement = ' ' + attribute.default_unit
              }

              let attributeTemp = {
                id: attributeId,
                value_name: attributeValue + complement,
                name: attribute.name
              }

              if (attribute.values) {
                const selectedValue = attribute.values.find(value => value.id === attributeValue)

                if (selectedValue) {
                  if (!selectedValue.custom) {
                    attributeTemp.value_id = selectedValue.id
                  }
                  attributeTemp.value_name = selectedValue.name + complement
                }
              }

              variationAttributes.push(attributeTemp)
            }
          }

          variations = [
            {
              attributes: variationAttributes,
              images: variation.images,
              price: variation.price,
              sku: variation.sku,
              stock: variation.stock,
              code: variation.code,
              saleAvailability: variation.saleAvailability
            }
          ]
        }

        if (this.product.medAnvisaCode === '') {
          this.product.medAnvisaCode = 'ISENTO'
        }

        const product = {
          _id: this.product._id.$oid,
          shippingFree: this.product.shippingFree,
          shippingFreeRule: this.product.shippingFreeRule,
          attributes: productAttributes,
          description: this.product.description,
          original: this.product,
          productId: this.product.productId,
          title: this.product.title,
          variations: variations,
          ncm: this.product.ncm,
          originType: this.product.originType,
          originDetail: this.product.originDetail,
          taxRuleId: this.product.taxRuleId,
          csosn: this.product.csosn,
          cest: this.product.cest,
          fci: this.product.fci,
          exTipi: this.product.exTipi,
          medAnvisaCode: this.product.medAnvisaCode,
          medExemptionReason: this.product.medExemptionReason,
          netWeight: this.product.netWeight,
          grossWeight: this.product.grossWeight
        }

        return product
      }
    },
    computed: {
      ...mapGetters('editPrices', [
        'isUseUniquePrice',
        'getProductUniquePrice'
      ]),
      ...mapFields({
        mercadoLivreAccounts: 'mercadoLivreAccounts.accounts'
      })
    },
    watch: {
      async 'product.shippingFree' () {
        if (!this.product.shippingFree) {
          this.product.shippingFreeRule = []
          return
        }
        this.loadingShippingRules = true
        this.accounts = (await api.mercadoLivre.getAccounts({})).items

        for (const account of this.accounts) {
          if (account.identifier === this.product.account.identifier) {
            this.announcementConfiguration = account
          }
        }
        await this.getShippingRules()
        this.loadingShippingRules = false
      },
      shippingRuleSelectedRegion () {
        this.product.shippingFreeRule = {
          rule: this.shippingRuleSelected,
          ruleRegion: this.shippingRuleSelectedRegion,
          acceptedMethods: this.acceptedMethods,
          default: this.defaultRule
        }
      },
      'category.attributes' (categoryAttributes) {
        if (!this.mlProductAttributes.length) {
          this.mlProductAttributes = Object.assign(this.product.attributes)
          this.product.attributes = []
        }

        for (let i in categoryAttributes) {
          const categoryAttribute = categoryAttributes[i]

          let attribute = this.product.attributes[categoryAttribute.id]

          if (attribute !== undefined) {
            continue
          }

          let attributeValue = null

          const productAttribute = this.mlProductAttributes.find(attribute => attribute.id === categoryAttribute.id)

          if (productAttribute) {
            attributeValue = categoryAttribute.values !== undefined ? productAttribute.value_id : productAttribute.value_name
          }

          if (attributeValue !== null) {
            if (categoryAttribute.allowed_units !== undefined) {
              for (const unit of categoryAttribute.allowed_units) {
                if (attributeValue.indexOf(` ${unit.id}`) !== -1) {
                  categoryAttribute.default_unit = unit.id
                }
              }

              const defaultUnit = categoryAttribute.default_unit

              if (defaultUnit !== undefined) {
                attributeValue = attributeValue.replace(` ${defaultUnit}`, '')
              }
            }

            this.product.attributes[categoryAttribute.id] = attributeValue
            continue
          }

          switch (categoryAttribute.id) {
            case 'BRAND':
              attributeValue = this.sourceProduct.brand || null
              break

            case 'SELLER_PACKAGE_WIDTH':
              attributeValue = this.sourceProduct.variations[0].width || null
              break

            case 'SELLER_PACKAGE_LENGTH':
              attributeValue = this.sourceProduct.variations[0].length || null
              break

            case 'SELLER_PACKAGE_HEIGHT':
              attributeValue = this.sourceProduct.variations[0].height || null
              break

            case 'SELLER_PACKAGE_WEIGHT':
              attributeValue = this.sourceProduct.variations[0].weight || null
              break
          }

          this.product.attributes[categoryAttribute.id] = attributeValue
        }
      }
    },
    components: {
      Loader,
      Panel,
      GeneralMain,
      Variation,
      GeneralAttributes,
      ProductEditBulkPrice,
      FiscalAttributes,
      FormGroup,
      RadioButton,
      Multiselect
    }
  }
</script>

<style lang="sass" scoped>
  .margin
    margin-top: 20px

  .icon-new-tab
    margin-bottom: 2px

  .product-catalog
    display: flex
    align-items: center

    .img-container
      display: flex
      justify-content: center
      align-items: center
      margin: 0 25px

      img
        max-width: 100%
        max-height: 75px

    .title
      font-size: 20px

    strong
      display: block
      margin-bottom: 5px

      .margin
        margin: 10px 0 15px 10px
</style>



// WEBPACK FOOTER //
// Product.vue?bef2252a